import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Title } from 'Components/frameworks/title/Title';
import { PaidService } from 'Components/widgets/paid-service/PaidService';
export const ESF_IMAGE = 'https://ns.clubmed.com/it/2020/esf.jpg';
export const EsfLayerIntroduction = ({ openEsfWidget }: { openEsfWidget: () => void }) => (
  <div className="mb-100 flex flex-col gap-20 md:flex-row">
    <div className="md:flex-1">
      <Icon
        {...asWidgetProps<ComponentProps<typeof Icon>>({
          className: 'mb-10 text-black',
          name: ICONS.SKI,
          width: '2rem',
        })}
      />
      <Title
        {...asWidgetProps<ComponentProps<typeof Title>>({
          className: 'text-sienna',
          theme: 'title-brand-n3',
        })}
      >
        {t('stays.upsells.esf.title')}
      </Title>
      <p className="text-14">{t('stays.upsells.esf.description')}</p>
    </div>
    <div className="md:flex-2">
      <PaidService
        {...asWidgetProps<ComponentProps<typeof PaidService>>({
          addLabel: t('booking.common.included'),
          className: 'mb-20',
          ctaType: 'disabled',
          icon: ICONS.SKI,
          label: t('stays.upsells.esf.included.title'),
          text: t('stays.upsells.esf.included.description'),
          withLoader: false,
        })}
      />
      <PaidService
        {...asWidgetProps<ComponentProps<typeof PaidService>>({
          addLabel: t('common.continue'),
          ctaType: 'add',
          headColor: COLORS.ORANGE,
          icon: ICONS.ON_DEMAND,
          imageUrl: ESF_IMAGE,
          label: t('stays.upsells.esf.onDemand.title'),
          onClick: openEsfWidget,
          text: t('stays.upsells.esf.onDemand.description'),
          withLoader: false,
        })}
      />
    </div>
  </div>
);
